import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { AnalysisSection } from "@/features/fermentation-journal/components/results";

export const Route = createFileRoute(
  "/fermentations/$group_id/results/analysis",
)({
  component: AnalysisPage,
});

function AnalysisPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="max-w-4xl">
      <AnalysisSection groupId={groupId} />
    </div>
  );
}
